// Generated from LogoEditor.g4 by ANTLR 4.5.2
// jshint ignore: start
var antlr4 = require('antlr4/index');

// This class defines a complete listener for a parse tree produced by LogoEditorParser.
function LogoEditorListener() {
	antlr4.tree.ParseTreeListener.call(this);
	return this;
}

LogoEditorListener.prototype = Object.create(antlr4.tree.ParseTreeListener.prototype);
LogoEditorListener.prototype.constructor = LogoEditorListener;

// Enter a parse tree produced by LogoEditorParser#prog.
LogoEditorListener.prototype.enterProg = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#prog.
LogoEditorListener.prototype.exitProg = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#line.
LogoEditorListener.prototype.enterLine = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#line.
LogoEditorListener.prototype.exitLine = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#cmd.
LogoEditorListener.prototype.enterCmd = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#cmd.
LogoEditorListener.prototype.exitCmd = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#procedureInvocation.
LogoEditorListener.prototype.enterProcedureInvocation = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#procedureInvocation.
LogoEditorListener.prototype.exitProcedureInvocation = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#procedureDeclaration.
LogoEditorListener.prototype.enterProcedureDeclaration = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#procedureDeclaration.
LogoEditorListener.prototype.exitProcedureDeclaration = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#parameterDeclarations.
LogoEditorListener.prototype.enterParameterDeclarations = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#parameterDeclarations.
LogoEditorListener.prototype.exitParameterDeclarations = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#colornameWithoutTypingErrors.
LogoEditorListener.prototype.enterColornameWithoutTypingErrors = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#colornameWithoutTypingErrors.
LogoEditorListener.prototype.exitColornameWithoutTypingErrors = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#func.
LogoEditorListener.prototype.enterFunc = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#func.
LogoEditorListener.prototype.exitFunc = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#repeat.
LogoEditorListener.prototype.enterRepeat = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#repeat.
LogoEditorListener.prototype.exitRepeat = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#whilee.
LogoEditorListener.prototype.enterWhilee = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#whilee.
LogoEditorListener.prototype.exitWhilee = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#block.
LogoEditorListener.prototype.enterBlock = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#block.
LogoEditorListener.prototype.exitBlock = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#ife.
LogoEditorListener.prototype.enterIfe = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#ife.
LogoEditorListener.prototype.exitIfe = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#expression.
LogoEditorListener.prototype.enterExpression = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#expression.
LogoEditorListener.prototype.exitExpression = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#comparisonOperator.
LogoEditorListener.prototype.enterComparisonOperator = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#comparisonOperator.
LogoEditorListener.prototype.exitComparisonOperator = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#sExpr.
LogoEditorListener.prototype.enterSExpr = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#sExpr.
LogoEditorListener.prototype.exitSExpr = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#term.
LogoEditorListener.prototype.enterTerm = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#term.
LogoEditorListener.prototype.exitTerm = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#factor.
LogoEditorListener.prototype.enterFactor = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#factor.
LogoEditorListener.prototype.exitFactor = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#nsFact.
LogoEditorListener.prototype.enterNsFact = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#nsFact.
LogoEditorListener.prototype.exitNsFact = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#value.
LogoEditorListener.prototype.enterValue = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#value.
LogoEditorListener.prototype.exitValue = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#deref.
LogoEditorListener.prototype.enterDeref = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#deref.
LogoEditorListener.prototype.exitDeref = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#colorname.
LogoEditorListener.prototype.enterColorname = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#colorname.
LogoEditorListener.prototype.exitColorname = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#rgb.
LogoEditorListener.prototype.enterRgb = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#rgb.
LogoEditorListener.prototype.exitRgb = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#colornumber.
LogoEditorListener.prototype.enterColornumber = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#colornumber.
LogoEditorListener.prototype.exitColornumber = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#make.
LogoEditorListener.prototype.enterMake = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#make.
LogoEditorListener.prototype.exitMake = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#print.
LogoEditorListener.prototype.enterPrint = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#print.
LogoEditorListener.prototype.exitPrint = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#quotedstring.
LogoEditorListener.prototype.enterQuotedstring = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#quotedstring.
LogoEditorListener.prototype.exitQuotedstring = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#name.
LogoEditorListener.prototype.enterName = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#name.
LogoEditorListener.prototype.exitName = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#fd.
LogoEditorListener.prototype.enterFd = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#fd.
LogoEditorListener.prototype.exitFd = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#bk.
LogoEditorListener.prototype.enterBk = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#bk.
LogoEditorListener.prototype.exitBk = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#rt.
LogoEditorListener.prototype.enterRt = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#rt.
LogoEditorListener.prototype.exitRt = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#lt.
LogoEditorListener.prototype.enterLt = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#lt.
LogoEditorListener.prototype.exitLt = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#cs.
LogoEditorListener.prototype.enterCs = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#cs.
LogoEditorListener.prototype.exitCs = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#ct.
LogoEditorListener.prototype.enterCt = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#ct.
LogoEditorListener.prototype.exitCt = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#pu.
LogoEditorListener.prototype.enterPu = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#pu.
LogoEditorListener.prototype.exitPu = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#pd.
LogoEditorListener.prototype.enterPd = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#pd.
LogoEditorListener.prototype.exitPd = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#pe.
LogoEditorListener.prototype.enterPe = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#pe.
LogoEditorListener.prototype.exitPe = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#ppt.
LogoEditorListener.prototype.enterPpt = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#ppt.
LogoEditorListener.prototype.exitPpt = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#ht.
LogoEditorListener.prototype.enterHt = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#ht.
LogoEditorListener.prototype.exitHt = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#st.
LogoEditorListener.prototype.enterSt = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#st.
LogoEditorListener.prototype.exitSt = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#setpc.
LogoEditorListener.prototype.enterSetpc = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#setpc.
LogoEditorListener.prototype.exitSetpc = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#setsc.
LogoEditorListener.prototype.enterSetsc = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#setsc.
LogoEditorListener.prototype.exitSetsc = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#home.
LogoEditorListener.prototype.enterHome = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#home.
LogoEditorListener.prototype.exitHome = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#stop.
LogoEditorListener.prototype.enterStop = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#stop.
LogoEditorListener.prototype.exitStop = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#setxy.
LogoEditorListener.prototype.enterSetxy = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#setxy.
LogoEditorListener.prototype.exitSetxy = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#setx.
LogoEditorListener.prototype.enterSetx = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#setx.
LogoEditorListener.prototype.exitSetx = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#sety.
LogoEditorListener.prototype.enterSety = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#sety.
LogoEditorListener.prototype.exitSety = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#random.
LogoEditorListener.prototype.enterRandom = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#random.
LogoEditorListener.prototype.exitRandom = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#sin.
LogoEditorListener.prototype.enterSin = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#sin.
LogoEditorListener.prototype.exitSin = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#cos.
LogoEditorListener.prototype.enterCos = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#cos.
LogoEditorListener.prototype.exitCos = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#tan.
LogoEditorListener.prototype.enterTan = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#tan.
LogoEditorListener.prototype.exitTan = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#arcsin.
LogoEditorListener.prototype.enterArcsin = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#arcsin.
LogoEditorListener.prototype.exitArcsin = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#arccos.
LogoEditorListener.prototype.enterArccos = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#arccos.
LogoEditorListener.prototype.exitArccos = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#arctan.
LogoEditorListener.prototype.enterArctan = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#arctan.
LogoEditorListener.prototype.exitArctan = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#abs.
LogoEditorListener.prototype.enterAbs = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#abs.
LogoEditorListener.prototype.exitAbs = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#sqrt.
LogoEditorListener.prototype.enterSqrt = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#sqrt.
LogoEditorListener.prototype.exitSqrt = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#mod.
LogoEditorListener.prototype.enterMod = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#mod.
LogoEditorListener.prototype.exitMod = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#power.
LogoEditorListener.prototype.enterPower = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#power.
LogoEditorListener.prototype.exitPower = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#log10.
LogoEditorListener.prototype.enterLog10 = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#log10.
LogoEditorListener.prototype.exitLog10 = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#waite.
LogoEditorListener.prototype.enterWaite = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#waite.
LogoEditorListener.prototype.exitWaite = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#wash.
LogoEditorListener.prototype.enterWash = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#wash.
LogoEditorListener.prototype.exitWash = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#setpw.
LogoEditorListener.prototype.enterSetpw = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#setpw.
LogoEditorListener.prototype.exitSetpw = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#circle.
LogoEditorListener.prototype.enterCircle = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#circle.
LogoEditorListener.prototype.exitCircle = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#setheading.
LogoEditorListener.prototype.enterSetheading = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#setheading.
LogoEditorListener.prototype.exitSetheading = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#number.
LogoEditorListener.prototype.enterNumber = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#number.
LogoEditorListener.prototype.exitNumber = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#comment.
LogoEditorListener.prototype.enterComment = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#comment.
LogoEditorListener.prototype.exitComment = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#pie.
LogoEditorListener.prototype.enterPie = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#pie.
LogoEditorListener.prototype.exitPie = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#ee.
LogoEditorListener.prototype.enterEe = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#ee.
LogoEditorListener.prototype.exitEe = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#eol.
LogoEditorListener.prototype.enterEol = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#eol.
LogoEditorListener.prototype.exitEol = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#maybeTo.
LogoEditorListener.prototype.enterMaybeTo = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#maybeTo.
LogoEditorListener.prototype.exitMaybeTo = function(ctx) {
};


// Enter a parse tree produced by LogoEditorParser#end.
LogoEditorListener.prototype.enterEnd = function(ctx) {
};

// Exit a parse tree produced by LogoEditorParser#end.
LogoEditorListener.prototype.exitEnd = function(ctx) {
};



exports.LogoEditorListener = LogoEditorListener;


//////////////////
// WEBPACK FOOTER
// ./src/app/interpreter/interpreter-editor/LogoEditorListener.js
// module id = ./src/app/interpreter/interpreter-editor/LogoEditorListener.js
// module chunks = main